import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import arrow from "../assets/arrow.svg";
import Help from "../components/Help";
import { NavLink, useNavigate } from "react-router-dom";
import { helpPagesData } from "../utils/helper";
import { DeleteForm, fetchFormList } from "../action/formaction";
import detail from "../assets/datail-view.svg";
import pencil from "../assets/pen1.svg";
import trash from "../assets/red-trash.svg";
import { useToast } from "../components/ToastProvider";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import Paginate from "../components/pagination";
const ContactForms = () => {
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [search, setSearch] = useState("");
  const { showToast } = useToast();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0
  });
  const navigate = useNavigate();
  const fetchformData = async () => {
    setLoading(true);
    const { page, limit } = pagination;
    const res = await fetchFormList(page, limit, search, sortField, sortOrder)
    if (res?.status === 1) {
      setFormData(res.data.list);
      setPagination((p) => ({
        ...p,
        total: Math.ceil(res.data.total / p.limit)   // ← FIXED
      }));
    }
    setLoading(false);
  }
  useEffect(() => {
    fetchformData();
  }, [pagination.page, pagination.limit, search, sortField, sortOrder]);

  const handlePageChange = (newPage) => {
    setPagination((p) => ({ ...p, page: newPage }));
  };

  const handlePageSizeChange = (newLimit) => {
    setPagination((p) => ({ ...p, limit: newLimit, page: 1 }));
  };
  const renderSortArrow = (field) => {
    if (sortField !== field) return "↕"; // no sort active yet
    return sortOrder === "asc" ? "↑" : "↓";
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc"); // default
    }
  };
  const handleEdit = (form) => {
    // recommended: navigate to edit route and fetch form details on that page using the id
    navigate(`/all-forms/edit/${form._id}`);

    // optional: pass the full object to avoid refetch on the edit page:
    // navigate(`/all-forms/edit/${form._id}`, { state: { form } });
  };
  const handleDeleteForm = async () => {
    if (!deleteId) return;

    setDeleteLoading(true);

    const res = await DeleteForm(deleteId);

    if (res?.status === 1) {
      showToast("Form deleted successfully", "success");
      setShowDeletePopup(false);
      fetchformData(); // refresh list
    } else {
      showToast(res?.message || "Failed to delete form", "error");
    }

    setDeleteLoading(false);
  };


  return (
    <>
      <PageHeader pageTitle="Forms">
    
          <NavLink to="/all-forms/create-from" className="btn-black">
            Create New
          </NavLink>
      
      </PageHeader>
      <div className="page-container">
        <div className="theme-card p-4">
          <div className="card-title pb-3">All Forms</div>
          <div className="table-responsive">
            <table className="pages-table">
              <thead>
                <tr>
                  <th>Form Name</th>
                  <th className="sortable" onClick={() => handleSort("createdAt")}>Date Created {renderSortArrow("createdAt")}</th>
                  <th>All Responses</th>
                  <th style={{ textAlign: 'center' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {/* {data.map((data, i) => (
                  <tr key={i}>
                    <td style={{ width: '80%' }}>{data.form_name}</td>
                    <td>{data.all_responses}</td>
                    <td style={{ textAlign: 'center' }}>
                      <NavLink to={`/${data.slug}`}><img src={arrow} alt="" /></NavLink>
                    </td>
                  </tr>
                ))} */}
                {loading && (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center", padding: "30px" }}>
                      <Spinner size="md" />
                    </td>
                  </tr>
                )}
                {!loading && formData.length === 0 && (
                  <tr>
                    <td colSpan="4" style={{ textAlign: "center", padding: "20px" }}>
                      No forms found.
                    </td>
                  </tr>
                )}
                {!loading &&
                  formData.length > 0 &&
                  formData.map((list) => (
                    <tr key={list._id}>
                      <td >{list.name}</td>
                      <td>   {moment(list.createdAt).format(
                        "DD/MM/YYYY"
                      )}</td>
                      <td>{list.total_response}</td>
                      <td style={{ textAlign: 'center' }}>
                        <div className="three-btn">
                          <img src={detail} alt="icon" onClick={() => navigate(`/all-forms/${list.shortcode}`)} />
                          <img src={pencil} alt="icon" onClick={() => handleEdit(list)} />
                          <img
                            src={trash}
                            alt="icon"
                            onClick={() => {
                              setDeleteId(list._id);
                              setShowDeletePopup(true);
                            }}

                          />

                        </div>

                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {/* PAGINATION */}
          {Boolean(pagination.total) && (
            <Paginate
              currentPage={pagination.page}
              totalPages={pagination.total}
              onPageChange={handlePageChange}
              pageSize={pagination.limit}
              onPageSizeChange={handlePageSizeChange}
            />
          )}
        </div>
      </div>
      {showDeletePopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h4 className="popup-title">Delete Form?</h4>
            <p className="popup-message">
              Are you sure you want to delete this form? This action cannot be undone.
            </p>

            <div className="popup-actions">
              <button
                className="btn-white"
                onClick={() => setShowDeletePopup(false)}
                disabled={deleteLoading}
              >
                No
              </button>

              <button
                className="btn-red"
                onClick={handleDeleteForm}
                disabled={deleteLoading}
              >
                {deleteLoading ? "Deleting..." : "Yes, Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default ContactForms;